import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { EventNames, useTracking } from "lib/tracking";
import { BidEntityType } from "lib/types/graphQLEnums";
import { graphql } from "../../../../generated/app-service-gql";
import {
  AddBidEntitiesMutation,
  AddBidEntitiesMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { updateBidEntityCache } from "./update_cache/updateBidEntityCache";

const ADD_BID_ENTITY_MUTATION = graphql(`
  mutation addBidEntities($id: String!, $entities: AddBidEntitiesInput!) {
    addBidEntities(id: $id, entities: $entities) {
      bidId
      bidName
      entityId
      entityType
    }
  }
`);

export function useAddBidEntity(
  options?: UseMutationOptions<
    AddBidEntitiesMutation,
    unknown,
    AddBidEntitiesMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const queryClient = useQueryClient();

  return useGraphQlMutation(ADD_BID_ENTITY_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      const entities = data.addBidEntities;
      await updateBidEntityCache({
        queryClient,
        isAdding: true,
        entities,
      });

      const hasCustomBuyer = variables.entities.entities.some(
        (e) => e.entityType === BidEntityType.CustomOrganisation,
      );

      logEvent(EventNames.bidDataAdded, {
        "Bid ID": variables.id,
        "Amount of entities": entities.length,
        "Free-text buyer": hasCustomBuyer,
      });

      options?.onSuccess?.(data, variables, context);
    },
  });
}
